module.exports = __webpack_public_path__ + "static/img/detail3.e7e2d82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/detail3.jpg
// module id = ThgA
// module chunks = 0